import { useQuery } from '@tanstack/react-query'
import { IKvitteringData } from '../../../ducks/kvittering/types'
import { adresseKeys, getIdFromPayload } from './helpers'
import { adresseApi } from './adresse-api'
import { IAdresseData, AdresseQueryPayload } from '../types'
import { IVirksomhetItem } from '../../../ducks/virksomhet-search/types'

export { useAdresse }

const useAdresse = (adressePayload: AdresseQueryPayload) => {
  const id = getIdFromPayload(adressePayload)

  const query = useQuery({
    queryKey: adresseKeys.get(id ?? ''),
    queryFn: async (): Promise<IAdresseData> => {
      const isKvittering = 'bildeIds' in adressePayload
      const data = isKvittering
        ? await adresseApi.getAdresseFromKvittering(
            adressePayload as IKvitteringData
          )
        : await adresseApi.getAdresseFromVirksomhet(
            adressePayload as IVirksomhetItem
          )

      if ('beliggenhetsadresse' in data) {
        return {
          beliggenhetsadresse: data.beliggenhetsadresse,
          postadresse: data.postadresse,
          orgNr: data.organisasjonsnummer,
          overordnetOrgNr: data.overordnetInfo.organisasjonsnummer,
        }
      }

      return { adresse: data }
    },
    enabled: !!id,
    retry: false,
  })

  return query
}
